import { ApiService } from "../..";

export const createSampleGroup = (data: {
  name: string;
  description: string;
}) => {
  return ApiService.baseAction("sample-group/create", { data }, "post");
};
